import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

// Actions
import { followGroup } from '../../actions/authActions';
import { toggleAuthModal, togglePrivacyModal } from '../../actions/navActions';
import { setAlert } from '../../actions/alertActions';

// Components - imported
import { Avatar } from '@material-ui/core';
import DefaultAvatar from 'react-avatar';

// Icons
import AddIcon from '@material-ui/icons/Add';
import LockIcon from '@material-ui/icons/Lock';
import VisibilityIcon from '@material-ui/icons/Visibility';
import SchoolIcon from '@material-ui/icons/School';
import PublicIcon from '@material-ui/icons/Public';
import LinkIcon from '@material-ui/icons/Link';
import PRIVATE_TYPES from '../../utils/constant_variables/PRIVATE_TYPES';

const GroupBlock = ({
    group_doc,
    followGroup,
    toggleAuthModal,
    togglePrivacyModal,
    setAlert,
    auth
}) => {

    const [checkFollow, setCheckFollow] = useState(false);
    const [followed, setFollowed] = useState(false);
    const [requestedFollow, setRequestedFollow] = useState(false);

    // Handle redirect to group's custom url
    const handleGoToCustomUrl = (customURL) => {
        console.log('About to Redirect to Custom URL..');

        window.open(customURL, "_blank");
    }

    const handleVisitGroup = () => {
        const isPrivateType = PRIVATE_TYPES.includes(group_doc?.privacy?.toLowerCase());

        window.location.href = `/groups/${group_doc._id}${!isPrivateType ? '?show=posts' : ''}`;
    }

    // Handle follow group
    const handleFollow = async () => {

        if(auth.user && group_doc) {

            // FLAG: can't follow student only groups without a verified school email
            if(group_doc.privacy === 'students only' && (!auth.user?.school_verified || !auth.user?.school_email.trim())) {

                togglePrivacyModal('students only');
                return;
            }

            try {
                await followGroup(group_doc._id, auth.user);

                if(group_doc.privacy === 'private' && !followed) {
                    // Toggle the requested follow status
                    setRequestedFollow(!requestedFollow);
                } else {
                    // Toggle the follow status
                    setFollowed(!followed);
                }
            } catch (error) {
                console.log('Error while trying to handle follow / unfollow');
                setAlert(error.message, 'danger');
            }

        } else {

            // Toggles the authentication modal for liking
            toggleAuthModal('follow');
        }
    }

    // Checks if the user has already followed the group
    if(auth.user && group_doc && !checkFollow) {
        if(auth.user.groups?.filter(temp_groupId => temp_groupId.toString() === group_doc._id).length > 0){
            setFollowed(true);
        } else if(group_doc.follow_requests?.filter(followRequest => followRequest.user._id.toString() === auth.user._id).length > 0) {
            setRequestedFollow(true);
        }
        
        // Marks that the check for likes has been performed
        setCheckFollow(true);
    }  
    
    return (
        <div key={group_doc._id} className="userTable__block">
            {/* User Avatar - left */}
            <div className="userTable__avatar">
                {group_doc.avatar ? (
                    <Avatar src={group_doc.avatar} />
                ) : (
                    <DefaultAvatar name={`${group_doc.name}`} />
                )}
            </div>

            {/* Display the user's name & username */}
            <div className="userTable__info">
                <h3>
                    {group_doc.name}
                </h3>
                <div style={{display: 'flex', alignItems: 'center', marginTop: '2px', fontSize:'13px', color: 'rgb(83, 100, 113)'}}>
                    {group_doc.privacy === 'public' && (
                        <Fragment>
                            <PublicIcon />
                            <p style={{marginLeft: '5px'}}>Public</p>
                        </Fragment>
                    )}
                    {group_doc.privacy === 'restricted' && (
                        <Fragment>
                            <VisibilityIcon />
                            <p style={{marginLeft: '5px'}}>Restricted</p>
                        </Fragment>
                    )}
                    {group_doc.privacy === 'private' && (
                        <Fragment>
                            <LockIcon />
                            <p style={{marginLeft: '5px'}}>Private</p>
                        </Fragment>
                    )}
                    {group_doc.privacy === 'students only' && (
                        <Fragment>
                            <SchoolIcon />
                            <p style={{marginLeft: '5px'}}>Students only</p>
                        </Fragment>
                    )}
                    <span style={{margin: '0 5px'}}>
                        &middot;
                    </span>
                    {group_doc.follower_count || '--'} member{group_doc.follower_count !== 1 && 's'}
                </div>
            </div>

            {/* Follow Btn */}
            {group_doc.url?.trim() ? (
                <Fragment>
                    <div style={{height: '100%', display: 'flex', alignItems: 'center', paddingRight: '10px'}}>
                        <div onClick={() => handleGoToCustomUrl(group_doc.url)} className='see_more_btn icon_18' style={{zIndex: 10}}>
                            {/* Icon */}
                            <LinkIcon />
                            <span style={{width: '5px'}}></span>
                            Visit 
                        </div>
                    </div>
                </Fragment>
            ) : (
                <Fragment>
                    {(auth.user && group_doc.creator?._id !== auth.user._id) && (
                        <div style={{height: '100%', display: 'flex', alignItems: 'center', paddingRight: '10px'}}>
                            <div onClick={handleFollow} className='see_more_btn icon_18' style={{zIndex: 10}}>
                                {/* Icon */}
                                {(!followed && !requestedFollow) && <AddIcon />}
                                <span style={{width: '5px'}}></span>
                                {followed ? 'Unfollow' : requestedFollow ? 'Requested' : 'Follow'}  
                            </div>
                        </div>
                    )}
                </Fragment>
            )}

            {/* Invisible overlay for catching mouse clicks around the 'Message' btn */}
            <div 
                onClick={handleVisitGroup} 
                style={{position: 'absolute', top: 0, bottom: 0, right: 0, left: 0, zIndex: 9}}
            ></div>
        </div>
    )
}

const mapStateToProps = state => ({
    auth: state.auth,
})

export default connect(mapStateToProps, { 

    // Connecting actions from Redux to the component
    followGroup,
    toggleAuthModal,
    togglePrivacyModal,
    setAlert
})(GroupBlock);